import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'sy-stepper',
  styleUrls: ['./scss/index.scss', './scss/tokens.scss'],
  shadow: true,
})
export class Stepper {
  /**
   * Defines whether the stepper should be rendered vertically. On mobile, the stepper will always be rendered vertically.
   */
  @Prop({ reflect: true }) vertical = false;

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
